import Vue from 'vue'

Vue.filter('percent', function (num, precision = 2) {
  if (typeof num !== 'number') return '-'

  let percent = Math.round((num * 100 * Math.pow(10, precision)))
  if (percent === 0 || percent === 100) {
    return percent + '%'
  }
  if (precision > 0) {
    percent = '' + percent
    percent = percent.substring(0, percent.length - precision) + '.' + percent.substr(percent.length - precision)
  }
  return percent + '%'
})



// WEBPACK FOOTER //
// ./src/filters.js